import React from 'react'
import { ViewStyle } from 'react-native'

import styled from 'styled-components/native'

import { ConversationList } from './ConversationList'
import { ConversationListEmpty } from './ConversationListEmpty'
import { ConversationListSkeleton } from './ConversationListSkeleton'
import { ChatSideBarHeader } from '../../molecules/chatSideBarHeader/ChatSideBarHeader'
import { MessengerUtilities, MessengerUtilityItems } from '../../molecules/messengerUtilities/MessengerUtilities'
import { Conversation, ConversationFilter } from '../../ui-models/messages/Conversations'
import { tID } from '../../utils/utils'

export type ChatLeftSideBarProps = {
  selectedClientId: string | null
  conversations: Conversation[]
  onComposePressed: () => void
  onConversationPressed: ({ clientId, externallySelected }: { clientId: string; externallySelected?: boolean }) => void
  onSmartSuggestionPress?: () => void
  smartSuggestionCounter?: number
  onTemplatePressed?: () => void
  onDraftsPressed?: () => void
  filters: ConversationFilter[]
  onFiltersChanged: (filters: ConversationFilter[]) => void
  isLoading: boolean
  openUtilityItem: MessengerUtilityItems | null
  scrolledToClientId?: string | null
  setOpenUtilityItem: (item: MessengerUtilityItems | null) => void
  setScrolledToClientId: (clientId: string | null) => void
  style?: ViewStyle
}

const Container = styled.View(({ theme }) => ({
  flexDirection: 'column',
  width: '320px',
  backgroundColor: theme.colors.backgroundPrimary,
}))

const UtilitiesContainer = styled.View(({ theme }) => ({
  borderBottomWidth: '1px',
  borderBottomColor: theme.colors.borderDefault,
  padding: `${theme.spacing['16px']} ${theme.spacing['12px']}`,
}))

export const ChatLeftSideBar: React.FC<ChatLeftSideBarProps> = ({
  conversations,
  onComposePressed,
  onConversationPressed,
  onSmartSuggestionPress,
  smartSuggestionCounter,
  onTemplatePressed,
  onDraftsPressed,
  selectedClientId,
  filters,
  onFiltersChanged,
  isLoading,
  openUtilityItem,
  scrolledToClientId,
  setOpenUtilityItem,
  setScrolledToClientId,
  style,
}) => {
  return (
    <Container testID={tID('ChatLeftSideBar')} style={style}>
      <ChatSideBarHeader onComposePressed={onComposePressed} filters={filters} onFiltersChanged={onFiltersChanged} />
      {(onSmartSuggestionPress || onTemplatePressed || onDraftsPressed) && (
        <UtilitiesContainer>
          <MessengerUtilities
            onSmartSuggestionPress={onSmartSuggestionPress}
            onTemplatesPress={onTemplatePressed}
            onDraftsPressed={onDraftsPressed}
            openUtilityItem={openUtilityItem}
            setOpenUtilityItem={setOpenUtilityItem}
            smartSuggestionCounter={smartSuggestionCounter}
          />
        </UtilitiesContainer>
      )}
      {isLoading ? (
        <ConversationListSkeleton />
      ) : conversations.length === 0 ? (
        <ConversationListEmpty hasFilters={filters.length > 0} onClearFiltersPressed={() => onFiltersChanged([])} />
      ) : (
        <ConversationList
          conversations={conversations}
          onConversationPressed={onConversationPressed}
          scrolledToClientId={scrolledToClientId}
          selectedClientId={selectedClientId}
          setScrolledToClientId={setScrolledToClientId}
        />
      )}
    </Container>
  )
}
